"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const RCController_1 = require("./RCController");
const index_1 = require("../index");
class RCSlaveController extends RCController_1.default {
    constructor() {
        super(...arguments);
        this.subscribeToMasterEvents = (masterId) => __awaiter(this, void 0, void 0, function* () {
            const subMasterOfflineMsg = index_1.DMSMessageFactory.newMessage(index_1.DMSMethod.SUBSCRIBE_NODE_EVENT, {
                subscriberNodeId: this.slaveId,
                subscriptionTargetNodeId: masterId,
                event: index_1.DMSMethod.NODE_INFO_OFFLINE
            });
            const subNodeOfflineResult = yield this.dmsClient.sendMessage(subMasterOfflineMsg, true);
            if (subNodeOfflineResult === null || subNodeOfflineResult === void 0 ? void 0 : subNodeOfflineResult.error) {
                throw subNodeOfflineResult.error;
            }
        });
        this.onMasterOffline = (message) => {
            this.delegate.onMasterDisconnected(message.payload.uid);
        };
        this.disconnect = () => {
            var _a;
            this.delegate = undefined;
            (_a = this.dmsClient) === null || _a === void 0 ? void 0 : _a.disconnect();
        };
        this.start = (masterId, delegate, callables) => __awaiter(this, void 0, void 0, function* () {
            try {
                this.masterId = masterId;
                this.slaveId = yield this.startImpl(delegate);
                const callableMethods = Object.keys(callables);
                callableMethods.forEach(method => {
                    const callable = callables[method];
                    this.dmsClient.registerCallable(method, callable);
                });
                this.dmsClient.registerCallable(index_1.DMSMethod.NODE_INFO_OFFLINE, {
                    implementation: this.onMasterOffline,
                });
                const pairMessage = index_1.DMSMessageFactory.newMessage(RCController_1.RCMethods.PAIR, { nodeId: this.slaveId }, masterId);
                const pairingResult = yield this.dmsClient.sendMessage(pairMessage, true);
                yield this.subscribeToMasterEvents(masterId);
                delegate.onPairedWithMaster(pairingResult);
                return this.slaveId;
            }
            catch (error) {
                this.disconnect();
                throw error;
            }
        });
        this.sendToMaster = (msg, awaitingResult) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            msg.targetNode = this.masterId;
            return (_a = this.dmsClient) === null || _a === void 0 ? void 0 : _a.sendMessage(msg, awaitingResult);
        });
    }
}
exports.default = RCSlaveController;
//# sourceMappingURL=RCSlaveController.js.map